// removed by extract-text-webpack-plugin
module.exports = {"screen-loader":"ScreenLoader__screen-loader","screenLoader":"ScreenLoader__screen-loader"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ScreenLoader/ScreenLoader.css
// module id = 1241
// module chunks = 8